import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';

import { SimpleToolbar } from 'rev-shared/htmlEditor/Constants';
import { toggleError } from 'rev-shared/util/directives/form/validation/validationUtil';

import { VideoCommentService } from './VideoComment.Service';

import styles from './add-video-comment.module.less';

@Component({
	selector: 'add-video-comment',
	templateUrl: './AddVideoComment.Component.html'
})
export class AddVideoCommentComponent {
	@Input() private parentCommentId: string;
	@Input() private videoId: string;
	@Input() public showCommentForm: boolean;
	@Output() public onCancelComment: EventEmitter<any> = new EventEmitter();
	@ViewChild('commentText', { read: ElementRef }) public commentTextElement: ElementRef;
	@ViewChild('commentText') public commentTextNgModel: NgModel;

	public readonly styles = styles;

	public editorConfig: CKEDITOR.config = { toolbar: SimpleToolbar };
	public processing: boolean;
	public text: string = '';

	constructor(
		private VideoCommentService: VideoCommentService
	) { }

	public addComment(): void {
		if (!this.text) { return; }

		this.processing = true;
		const comment = {
			parentCommentId: this.parentCommentId,
			videoId: this.videoId,
			text: this.text
		};

		(
			this.parentCommentId ?
				this.VideoCommentService.addChildVideoComment(comment) :
				this.VideoCommentService.addRootVideoComment(comment)
		).then(() => this.resetComment())
			.catch(err => {
				this.resetComment();
				//existing functionality.
				//Need to revisit..
				if (err.hasIssue('VideoCommentNotValid')) {
					toggleError(this.commentTextNgModel.control, 'maxlength', true);
				}
			}
			);
	}

	public resetComment(): void {
		this.text = '';
		this.processing = false;
		this.showCommentForm = false;
		this.commentTextNgModel.control.markAsPristine({ onlySelf: true });

		this.onCancelComment.emit();
	}

	public activateCommentForm(): void {
		this.showCommentForm = true;
	}

	public onEditorLoaded(htmlEditor: any): void {
		setTimeout(() => {
			htmlEditor.editorComponent.editorElement.focus();
		}, 100);
	}
}
